import { IUpdatePasswordProfile } from "../ContextProfileTypes";

export const valuesDefaultUpdatePasswordProfile: IUpdatePasswordProfile = {
  password_new_repeat: "",
  password_currency: "",
  password_new: "",
};
